import React, { Component } from 'react';
import Homesearch from './homesearch';
import HomeLink from './homelink';
import Axios from 'axios';
import { BASE } from "../api/api";
import Footer from '../footer/footerbkp';
import Header from '../header/newheader'
import HomeResearch from './homeResearch';
import HomeEvents from './homeEvents';
import HomeBooks from './homebooks';
import '../css/materialize.css'
import '../css/dev.css'
import '../css/responsive.css'
import './home.css'

class HomeNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search_menu_opt: localStorage.getItem('lang') ? true : false,
      token: localStorage.getItem('token') ? localStorage.getItem('token') : ''
    }
  }

  topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  langSelected(e) {
    console.log(e)
    let tmp;
    if (e == "ara") {
      tmp = true;
    }
    else
      tmp = false;
    console.log(tmp)
    this.setState({
      search_menu_opt: undefined
    })
    this.setState({
      search_menu_opt: tmp
    })
  }

  // signout() {
  //   localStorage.removeItem('token');
  //   this.setState({ show_menu: false })
  //   window.location.href = '/'
  // }

  signout() {
    localStorage.removeItem('token');
    localStorage.removeItem('expirytime');
    localStorage.removeItem('expiryref');
    window.location.href = '/'

  }


  refreshexp(){
    let s = new Date();
    s.setSeconds(s.getSeconds()+1800);
    localStorage.setItem('expiryref', s)
  }


  checkexpiry(){
    if(localStorage.getItem('expiryref')){
      let expref=Date.parse(localStorage.getItem('expiryref'))
      let s = new Date();
      if(s>expref){
        this.fillalert('Session Expired!Logging Out')
          this.signout()
      }
      else{
        this.refreshexp()
      }
      
    }
    else{
      this.fillalert('Session Expired!Logging Out')
      this.signout()
       
  }
  }

  componentWillMount(){
    if(this.state.token)
        this.checkexpiry()
  }
  

  // componentWillMount() {
  //   if(this.state.token)
  //   Axios(BASE+'/oauth/debug?_format=json', {
  //     method: 'GET',
  //     headers: {
  //       'Authorization': "Bearer " + this.state.token,
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json'
  //     }
  // })
  //   .then((data) => { 
  //     console.log(data,'suggitems')
  //     if(data.data.roles[0]!=="authenticated"){
  //       this.fillalert('Session Expired!Logging Out')
  //       this.signout()
  //     }
  //   })
  // }

  fillalert(msg) {
    this.setState({
      filltext: msg,
      fillalert: true
    })
    setTimeout(
      function () {
        this.setState({
          fillalert: null
        })
      }
        .bind(this),
      3000
    );
  }

  render() {

    return (
      <div className='biopage'>
        {this.state.fillalert ? <div className="fill-alert">{this.state.filltext}</div> : ''}
        <Header langSelected={(e) => this.langSelected(e)} />
        <Homesearch history={this.props.history} />
        <div className="newhomegrey">
          <div className="container">
            <div className="row">
              <div className="col s12 m6 l6">
                <HomeBooks isArabic={this.state.search_menu_opt} />
              </div>
              <div className="col s12 m6 l6">
                <HomeResearch isArabic={this.state.search_menu_opt} />
              </div>
            </div>
            <div className="row">
              <div className="col s12 m12 l12">
                <HomeEvents isArabic={this.state.search_menu_opt} />
              </div>
            </div>
          </div>
        </div>
        <HomeLink isArabic={this.state.search_menu_opt} />
        <Footer />
      </div>
    )

  }

}

export default HomeNew;
